import React from 'react'

export function Invoice8p5inchStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* Modify Parent Style Content Inner */
        #content{
          background-color: whitesmoke
        }

        .report-wrapper { border: solid 0.5px lightgrey; }

        /* INVOICE ITEM CONTAINER */
        #invoice-8p5inch {
          display: flex;
          flex-direction: column;
          justify-content: stretch;
          background-color: white;
          /*border: solid 1px lightgrey;*/
          font-size: 0.95rem;
          padding: 20px;
          /*font-family: 'Courier New';*/
          box-sizing: border-box;
          /*box-shadow: 2px 2px 10px 2px #BBB;*/
        }

        /* HEADER */
        #invoice-item-header {
          /*background-color: green;*/
          display: flex;
          flex-direction: row;
          justify-content: stretch;
        }
        #invoice-item-header-left {
          /*background-color: violet;*/
          display: flex;
          flex-direction: column;
          align-items: left;
          flex: 1;
        }
        #invoice-item-header-right {
          /*background-color: yellow;*/
          display: flex;
          flex-direction: column;
          align-items: right;
          justify-content: flex-start;
          flex: 1;
        }
        #table-customer-details th, #table-customer-details td {
          /*border: 1px solid green;*/
          vertical-align: top;
        }


        /* INVOICE PARTICULARS */
        .table-invoice-item {
          /*border: 3px solid blue;*/
          margin-top: 10pt;
          border-spacing: 0;
          /*width: 100%;*/
        }
        .table-invoice-item th, .table-invoice-item td {
          /*border: 3px solid blue;*/
        }


        /* INVOICE SUMMARY */
        .invoice-summary-container {
          width: 43%;
          align-self: flex-end;
          display: flex;
          flex-direction: column;
          margin-top: 10pt;
          display: flex;
          justify-content: flex-end;
        }
        .invoice-summary-item {
          display: flex;
          flex: 2;
        }
        .invoice-summary-item.discount { margin-left: 10px; }
        .item-label { flex: 3;}
        .item-data {
          flex: 2;
          text-align: right;
        }
        .discount-info-label { margin-left: 5px; flex: 1; }
        .discount-info-data { flex: 3; }
        .discount-info-data.signature-underline { border-bottom: solid 1px black; }

        .invoice-company-name-address-container {
          display: flex;
          flex-direction: column;
          margin-bottom: 10px;
        }

        .log-container {
          font-size: 0.8rem;
          margin-top: 10px;
          border-top: dotted 0.3px black;
        }
      `}
      </style>
    </React.Fragment>
  )
}

export function Invoice58mmStyle() {
  return (
    <style jsx='true'>
    {`
      .invoice-58mm {
        display: flex;
        visibility: hidden;
        flex-direction: column;
        align-items: center;
        padding: 10px;
        height: 0vh;
        overflow: hidden;
        box-sizing: border-box;
      }

      #invoice-58mm-header {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 10px;
        width: 100%;
      }

      #invoice-details-container {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        width: 100%;
      }

      .items-list { width: 100%; }

      .invoice-summary-container.fifty-eight-mm { width: 100%; }

      .invoice-details-show {
        display: flex;
        flex-direction: column;
      }
      .invoice-details-hide { display: none; }
    `}
    </style>
  )
}
